import FingerprintJS from '@fingerprintjs/fingerprintjs'

// 获取设备指纹ID
export async function getFingerprintId() {
  try {
    const fp = await FingerprintJS.load()
    const result = await fp.get()
    return result.visitorId
  } catch (error) {
    console.error('获取指纹ID失败:', error)
    return null
  }
}